module.exports = __webpack_public_path__ + "static/media/service-desk-ng4.1953cadd.svg";